module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CR - Costa Rica.6f7161a5.svg";